import { render, staticRenderFns } from "./WidgetPreview.vue?vue&type=template&id=1e7b3634&scoped=true"
import script from "./WidgetPreview.vue?vue&type=script&lang=js"
export * from "./WidgetPreview.vue?vue&type=script&lang=js"
import style0 from "./WidgetPreview.vue?vue&type=style&index=0&id=1e7b3634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7b3634",
  null
  
)

export default component.exports